import type { JSX } from 'react';
import { Box, LinearProgress, Stack, Typography } from '@mui/material';

import crvSystemsMark from '../assets/branding/crv-systems-mark.svg';

export function RouteLoadingFallback(): JSX.Element {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      role="status"
      aria-live="polite"
      sx={{ minHeight: '48vh', py: 6 }}
    >
      <Box component="img" src={crvSystemsMark} alt="" sx={{ width: 52, height: 52 }} />
      <Stack spacing={1} alignItems="center" sx={{ width: 'min(220px, 80vw)' }}>
        <Typography variant="body2" color="text.secondary" fontWeight={700}>
          Loading CRV Systems
        </Typography>
        <LinearProgress sx={{ width: '100%', height: 4, borderRadius: 999 }} />
      </Stack>
    </Stack>
  );
}
